import { Skeleton } from "@/components/ui/skeleton";

const MetricsSkeleton = () => (
  <div className="space-y-6 animate-in fade-in">
    {/* Summary Cards Skeleton */}
    <div className="grid grid-cols-3 gap-3">
      {[1, 2, 3].map(i => (
        <div key={i} className="bg-card rounded-xl p-4 shadow-card border border-border flex flex-col items-center gap-2">
          <Skeleton className="w-5 h-5 rounded-full" />
          <Skeleton className="h-6 w-16" />
          <Skeleton className="h-3 w-12" />
        </div>
      ))}
    </div>

    {/* Chart Skeleton */}
    <div className="bg-card rounded-2xl p-5 shadow-card border border-border space-y-4">
      <div className="flex gap-2">
        {[1, 2, 3].map(i => (
          <Skeleton key={i} className="h-8 w-20 rounded-lg" />
        ))}
      </div>
      <Skeleton className="h-[220px] w-full rounded-lg" />
    </div>

    {/* History Skeleton */}
    <div className="space-y-3">
      <Skeleton className="h-5 w-24" />
      {[1, 2, 3].map(i => (
        <div key={i} className="bg-card rounded-xl p-4 shadow-card border border-border space-y-2">
          <Skeleton className="h-4 w-48" />
          <div className="flex gap-3">
            <Skeleton className="h-3 w-14" />
            <Skeleton className="h-3 w-20" />
            <Skeleton className="h-3 w-20" />
          </div>
        </div>
      ))}
    </div>
  </div>
);

export default MetricsSkeleton;
